export enum Colors {
  // Risk colors (standardized)
  SUCCESS_GREEN = '#0DAB6E',
  SUCCESS_GREEN_LIGHT = '#EBF7F0',
  WARNING_ORANGE = '#E38100',
  WARNING_ORANGE_LIGHT = '#FBF3E9',
  ERROR_RED = '#FD5745',
  ERROR_RED_LIGHT = '#FFEDEB',

  // Brand colors
  BRAND_BLUE = '#4566EB',
  PRIMARY_DARK = '#0E1944',

  // Risk type colors
  KYB_PURPLE = '#735BF6',
  FIRST_PARTY_ORANGE = '#FF9151',
  SYNTHETIC_BLACK = '#172455',

  // Text/UI grays
  NEUTRAL_GRAY = '#676E8B',
  LIGHT_GRAY = '#B2B8CF',
  BORDER_GRAY = '#D9DDF0',

  // Backgrounds
  WHITE = '#FFFFFF',
  CARD_BACKGROUND = '#2A355F',
  SIDEBAR_ACTIVE = '#E0E2F1',

  // Status colors
  ACTIVE_STATUS_BG = '#E8FAF0',
  ACTIVE_STATUS_TEXT = '#10A37F',
  INACTIVE_STATUS_BG = '#FFE9E8',
  INACTIVE_STATUS_TEXT = '#B42318',
  WARNING_STATUS_BG = '#FFF4E5',
  WARNING_STATUS_TEXT = '#B54708',

  // Network colors
  ADDRESS_NODE_BLUE = '#07A8FF',
  LOW_CONFIDENCE_EDGE = '#B8C5F2',
  HIGH_CONFIDENCE_EDGE = '#B2B8CF',

  // Risk level backgrounds
  LOW_RISK_BG = '#EBFFF3',
  MODERATE_RISK_BG = '#FFF2E2',
  HIGH_RISK_BG = '#FFE6E3',
  BORDERLINE_YELLOW = '#FFC107',

  // Businesses table risk colors
  TABLE_LOW_RISK = '#0DAB6E',
  TABLE_RISK_WARNINGS = '#FF9800',
  TABLE_HIGH_RISK = '#DC2626',

  // Additional UI colors
  PERSON_NODE_BLUE = '#4566EB',
  PERSON_NODE_STROKE = '#0148A2',
  ADDRESS_NODE_STROKE = '#0B9EEE',
  COMPANY_NODE_STROKE = '#000B19',
  NO_MATCH_PINK = '#FFB3BA',
}
